import { render } from "./NewsPost.vue?vue&type=template&id=475f1f22"
import script from "./NewsPost.vue?vue&type=script&lang=js"
export * from "./NewsPost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__